<template>
<div class="index page_fenlei clearfix">
	<!-- 左侧分类 -->
    <div class="page_left f-l">
		<ul class="tabsColum">
			<li :class="item.status ? 'tab active': 'tab'" v-for="item in cateList" :key="item.name" @click="clickTab(item)">{{item.name}}</li>
		</ul>
	</div>
	<!-- 右侧内容 -->
	<div class="page_right f-l">
		<ul class="list clearfix">
			<li class="item f-l" v-for="item in subCateList" :key="item.id" @click="goGoodsList(item)">
				<div class="item_tu">
					<img :src="imageUrl+item.sthumb" alt="" class="thumb">
				</div>
				<div class="item_title">{{ item.sname }}</div>
			</li>
		</ul>
	</div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "goodsFenlei",
    data() {
        return {
			publicPath: process.env.BASE_URL,
			imageUrl: this.$publicData.uploadImage,
			cateList:[
			],
			subCateList: [],
			cateId: null, // 分类id
			is_park: this.$route.query.is_park, // 1园区商城
			is_blockchain: this.$route.query.is_blockchain // 区块链标识 1
        };
    },
    created: function () {
		//根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
					'naviTitle':'筛选'
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = "";
					}
					this.getCateList()
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
			this.token = this.$store.getters.token;
			this.getCateList()
        }
    },
    methods: {
		// 获取商品分类
		getCateList(){
			var params = {
                token: this.token,
            };
            this.$api.shop.goodsType(params).then((res) => {
                if (res.code == 200) {
                    console.log(res);
					this.cateList = res.result;
					if (this.cateList.length > 0) {
						this.clickTab(this.cateList[0])
					}
					
                } else {
                    this.$toast(res.message);
                }
            });
		},
		// 切换分类
		clickTab(item){
			this.cateId = item.id
			for(var i in this.cateList){
				if(this.cateList[i].id == item.id){
					item.status = 1	
					this.subCateList = item.childs
				} else {
					this.cateList[i].status = 0
				}
			}
		},
		// 通过分类id 请求数据
		// 进入商品分类列表
		goGoodsList(item){
			var path = '/goods/list'
			if(this.is_park){
				path = '/parkmall/goods/list'
			}
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
				var p = "?cartId=" + item.sid+'&is_blockchain='+ this.is_blockchain;
                var params = {
                    data: {
                        url: this.$publicData.clientUrl + path + p
                    },
                };
                this.$bridge.callhandler( "sdjy://public/openNewWebView", params, (data) => {

					}
                );
            } else {
                this.$router.push({
					path: path,
					query: {
						cartId: item.sid,
						is_blockchain: this.is_blockchain
					}
				})
            }
		}
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
